export default __webpack_public_path__ + "static/media/DealerMethodsMockup.png.webp";